import { render, staticRenderFns } from "./PreviewFileModal.vue?vue&type=template&id=482929fc&scoped=true"
import script from "./PreviewFileModal.vue?vue&type=script&lang=js"
export * from "./PreviewFileModal.vue?vue&type=script&lang=js"
import style0 from "./PreviewFileModal.vue?vue&type=style&index=0&id=482929fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482929fc",
  null
  
)

export default component.exports